import type { MessageKey } from '../i18n/catalog';

type ReminderFrequency = 'off' | 'daily' | 'weekly';
type ReminderRecipient = 'in-app' | 'this-device';

export const reminderDeliveryNoticeKey = (
  frequency: ReminderFrequency,
  requestedRecipient: ReminderRecipient,
  savedRecipient: ReminderRecipient,
): MessageKey | null => {
  if (frequency === 'off' || requestedRecipient !== 'this-device') return null;
  return savedRecipient === 'this-device'
    ? 'preferences.reminderDeviceEnabled'
    : 'preferences.reminderFallback';
};
